import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { Button } from 'antd';

import { Modrawer } from '../Modrawer';

const ImportantInformation = ({
  openInfo,
  setOpenInfo
}: {
  openInfo: boolean;
  setOpenInfo: (open: boolean) => void;
}) => {
  return (
    <Modrawer
      open={openInfo}
      title={<div className='text-center'>Informações importantes</div>}
      onCancel={() => setOpenInfo(false)}
      width={420}
      footer={[
        <div className='flex w-full flex-col justify-center' key='info-footer'>
          <span className='text-content-title self-center! pb-1 text-sm font-semibold'>Ainda precisa de ajuda?</span>

          <Button
            className='override-button-base! w-full md:w-auto'
            id='btn-help-center'
            type='default'
            key='help'
            onClick={() => window.open('https://ajuda.eduzz.com/', '_blank')}
          >
            Central de Ajuda
          </Button>
        </div>
      ]}
    >
      <div className='flex flex-col gap-6 px-2 py-4'>
        <div className='flex flex-col gap-4'>
          <div className='text-content-title text-base font-semibold'>O que posso cadastrar como produto?</div>

          <div className='flex flex-col gap-3'>
            <div className='flex gap-4'>
              <CheckCircleFilled className='mb-4 shrink-0 text-sm text-lime-600!' />
              <span className='text-content-title'>
                E-books e livros digitais (de sua autoria ou com direito de comercialização);
              </span>
            </div>

            <div className='flex gap-4'>
              <CheckCircleFilled className='mb-4 shrink-0 text-sm text-lime-600!' />
              <span>Materiais em PDF, DOCX, EPUB ou ZIP, como apostilas, guias, roteiros e planilhas;</span>
            </div>

            <div className='flex gap-4'>
              <CheckCircleFilled className='mb-4 shrink-0 text-sm text-lime-600!' />
              <span>Arquivos complementares de cursos, como exercícios, listas de estudo ou bônus digitais;</span>
            </div>
          </div>
        </div>

        <div className='flex flex-col gap-4'>
          <div className='text-content-title text-base font-semibold'>O que não posso cadastrar como produto?</div>

          <div className='flex flex-col gap-3'>
            <div className='flex gap-4'>
              <CloseCircleFilled className='mb-4 shrink-0 text-sm text-red-600!' />
              <span className='text-content-title'>
                Arquivos com dados pessoais (listas de e-mails, CPF, RG, telefones etc.);
              </span>
            </div>

            <div className='flex gap-4'>
              <CloseCircleFilled className='mb-4 shrink-0 text-sm text-red-600!' />
              <span>Conteúdos eróticos ou pornográficos, sem propósito educacional ou de bem-estar;</span>
            </div>

            <div className='flex gap-4'>
              <CloseCircleFilled className='mb-4 shrink-0 text-sm text-red-600!' />
              <span>Materiais que prometem ganhos fáceis, esquemas de pirâmide ou afiliações enganosas;</span>
            </div>

            <div className='flex gap-4'>
              <CloseCircleFilled className='mb-4 shrink-0 text-sm text-red-600!' />
              <span>Conteúdos de terceiros sem autorização ou direitos de uso.</span>
            </div>
          </div>
        </div>
      </div>
    </Modrawer>
  );
};

export default ImportantInformation;
